'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var $schema = "http://json-schema.org/draft-07/schema";
var $id = "Entity";
var description = "The parts of the format that's common to all versions/kinds of entity.";
var examples = [
	{
		apiVersion: "backstage.io/v1alpha1",
		kind: "Component",
		metadata: {
			name: "LoremService",
			description: "Creates Lorems like a pro.",
			labels: {
				product_name: "Random value Generator"
			},
			annotations: {
				docs: "https://github.com/..../tree/develop/doc"
			}
		},
		spec: {
			type: "service",
			lifecycle: "production",
			owner: "tools"
		}
	}
];
var type = "object";
var required = [
	"apiVersion",
	"kind",
	"metadata"
];
var additionalProperties = false;
var properties = {
	apiVersion: {
		type: "string",
		description: "The version of specification format for this particular entity that this is written against.",
		minLength: 1,
		examples: [
			"backstage.io/v1alpha1",
			"my-company.net/v1",
			"1.0"
		]
	},
	kind: {
		type: "string",
		description: "The high level entity type being described.",
		minLength: 1,
		examples: [
			"API",
			"Component",
			"Domain",
			"Group",
			"Location",
			"Resource",
			"System",
			"Template",
			"User"
		]
	},
	metadata: {
		$ref: "EntityMeta"
	},
	spec: {
		type: "object",
		description: "The specification data describing the entity itself."
	},
	relations: {
		type: "array",
		description: "The relations that this entity has with other entities.",
		items: {
			$ref: "common#relation"
		}
	},
	status: {
		$ref: "common#status"
	}
};
var entitySchema = {
	$schema: $schema,
	$id: $id,
	description: description,
	examples: examples,
	type: type,
	required: required,
	additionalProperties: additionalProperties,
	properties: properties
};

exports.$id = $id;
exports.$schema = $schema;
exports.additionalProperties = additionalProperties;
exports.default = entitySchema;
exports.description = description;
exports.examples = examples;
exports.properties = properties;
exports.required = required;
exports.type = type;
//# sourceMappingURL=Entity.schema.json.cjs.js.map
